import Actions from '../actions/actions';
import supportItemsCRUDActions from '../actions/SupportItemsCRUDActions';
import { SupportItem, SupportItemsListModel } from '../model/SupportItemModel';

type ActionType = {
  type: string;
  entities: {
    items: SupportItem[];
  };
};

const initialState: SupportItemsListModel = {
  busy: false,
  entities: [],
};

export const supportItems = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case supportItemsCRUDActions.retrievedAllAction:
      return {
        ...state,
        entities: action.entities.items,
      };
    case supportItemsCRUDActions.busyAction:
      return {
        ...state,
        busy: true,
      };
    case supportItemsCRUDActions.unbusyAction:
      return {
        ...state,
        busy: false,
      };
    case Actions.UNBUSY:
      return {
        ...state,
        busy: false,
      };
    default:
      return state;
  }
};
